import type { Dayjs } from 'dayjs';

export type LoginRegisterFormType = 'default' | 'login' | 'register';

export interface LoginRegisterFormData {
  email: string;
  password: string;
  verificationCode: string;
  gender: string;
  birthday: Dayjs | null;
  telephone: string;
  tel_code: string;
}

export enum ELoginRegisterCloseType {
  LOGIN = 'login',
  REGISTER = 'register',
  CLOSE = 'close',
  BACK = 'back',
}
